import { Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import { Sidebar } from './components/Sidebar.js';
import { AuthGuard } from './components/AuthGuard.js';
import { GlobalEventListener } from './components/GlobalEventListener.js';
import { CommandBar } from './components/CommandBar.js';

export function App() {
  return (
    <AuthGuard>
      <div className="flex h-screen w-screen overflow-hidden text-text-primary">
        <Sidebar />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
      <GlobalEventListener />
      <CommandBar />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: 'rgba(14,58,68,0.95)',
            border: '1px solid rgba(13,207,184,0.25)',
            color: '#f0fafa',
            backdropFilter: 'blur(18px)',
            fontFamily: 'IBM Plex Sans, system-ui, sans-serif',
            fontSize: '13px',
          },
        }}
      />
    </AuthGuard>
  );
}
